import Mock from '../mock'
import axios from 'axios.js'
import { buildApiUrl } from 'fake-db/apiConfig'

Mock.onPost(/^\/api\/knowledge\/[a-z-]+$/).reply(async (config) => {
    const action = config.url.split('/').pop()
    try {
        const response = await axios.post(buildApiUrl(`knowledge/dispatch/?action=${encodeURIComponent(action)}`), JSON.parse(config.data || '{}'), { timeout: 20000 })
        if (!response.data || typeof response.data !== 'object') {
            console.error('База знаний: ответ сервера не является JSON', response.status, response.data)
            return [502, { errorInfo: 'Не удалось загрузить базу знаний. Попробуйте позже.' }]
        }
        return [response.status, response.data]
    } catch (error) {
        const body = error?.response?.data
        if (typeof body === 'string') console.error('База знаний: некорректный ответ сервера', body)
        return [error?.response?.status || 502, body && typeof body === 'object' ? body : { errorInfo: 'Нет связи с базой знаний. Попробуйте ещё раз.' }]
    }
})
